import React from 'react'
import Project from './Project';
import { Breakpoint } from 'react-socks';
import '../styles/Work.scss'

function Work({projects}) {

  return (
    <div className='work'>
        <Breakpoint large up>
          <div className='work-title'>Projects</div>
          <div className='work-project'>
            {projects.map(({name, url, demo}) => (
              <Project source={name} url={url} demo={demo}/>
            ))}
          </div>
        </Breakpoint>
        <Breakpoint medium down>
          <div className='work-title'>Projects</div>
            <div className='work-project'>
              {projects.map(({name, url, demo}) => (
                <Project source={name} url={url} demo={demo}/>
              ))}
          </div>
        </Breakpoint>
    </div>
  )
}

export default Work
